import Vue from 'vue'
import { getUserInfo, removeLoginInfo, removeUserInfo } from '@/api/config.js'
import { desEncrypt } from '@/utils';
export default {
	namespaced: true,
	state: {
		userInfo: getUserInfo()
	},
	mutations: {
		SET_USERINFO(state, data) {
			state.userInfo = data;
		}
	},
	actions: {
		async GetUserInfoHandle({ commit }, abort = true){
			let res = await Vue.prototype.$http('userInfo', {}, {abort});
			if(res.code === 1){
				commit('SET_USERINFO', res.data);
				return res.data;
			}else{
				return res;
			}
		},
		async LogoutAction({ commit }, { that }) {
			await that.$http('logout');
			removeLoginInfo();
			removeUserInfo();
			commit('SET_USERINFO',{});
			that.$router.replace({
				name: 'login'
			})
		},
		async LoginAction({ dispatch }, { params , that}) {
			let logPams = { ...params }
			logPams.desStr = desEncrypt(JSON.stringify({"pStr": logPams.desStr}));
			let res = await that.$http('login', logPams);
			if(res.code === 1){
				let res1 = await dispatch('GetUserInfoHandle', false);
				/*if(!res1.tagIds){
					that.$router.replace({
						name: 'interested'
					})
				}else{
					that.$backRef(that);
				}*/
				that.$backRef(that);
			}
		},
		async RegisterAction({ dispatch }, { params , that}) {
			let regPams = { ...params };
			regPams.password = desEncrypt(regPams.password);
			let res = await that.$http('register', regPams);
			if(res.code === 1){
				that.$dialog.confirm('注册成功，是否要自动登录？',{
					okText: '取消',
					cancelText: '确定',
					reverse: true
				}).then(() => {
					that.$router.push({
						name: 'login'
					})
				}).catch(err => {
					dispatch('LoginAction', {
						params: {
							identity: params.username,
							desStr: params.password
						},
						that
					});
				})
			}
		}
	}
}
